import { TPromoSearchTypes } from '../types/promoSearchTypes';

export function getPromoSearchFilterValuesByType(
  key: keyof NonNullable<TPromoSearchTypes>,
  promoSearchTypes: TPromoSearchTypes,
) {
  if (!promoSearchTypes) {
    return [];
  }

  return promoSearchTypes[key].map(item => item.value);
}
